import type { CreateItem } from '@/widgets/app-shell';

/** Mục "Tạo mới" của module ở thanh trên (lọc theo module bật + quyền). */
export const createItems: CreateItem[] = [{ label: 'Nhân sự', icon: 'staff', to: '/nhan-su', search: { new: 1 }, perm: 'hr.manage', module: 'hr' }];
